module.exports = __webpack_public_path__ + "img/LUB00388.4033a585.png";